/**
 * @desc getLogisticsChanneProviderByAono
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.ToLogisticsChannelResponseDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/logistics/getLogisticsChanneProviderByAono`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
